/* ============================================================
   LOADEX theme JS - homepage interactions + cart/product
   ============================================================ */

/* ---------- Mobile nav ---------- */
(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  nav.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  });
})();

/* ---------- Smooth scroll for on-page anchors ---------- */
(function () {
  document.querySelectorAll('a[href*="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      var hashIndex = href.indexOf('#');
      if (hashIndex < 0) return;
      var hash = href.slice(hashIndex);
      if (hash === '#' || hash.length < 2) return;
      // only intercept same-page anchors
      var path = href.slice(0, hashIndex);
      if (path && path !== window.location.pathname && path !== '/' && path.indexOf('#') !== 0) return;
      var target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 72;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });
})();

/* ---------- FAQ accordion ---------- */
(function () {
  var lists = document.querySelectorAll('[data-faq]');
  lists.forEach(function (list) {
    var items = list.querySelectorAll('.faq__item');
    items.forEach(function (item) {
      var q = item.querySelector('.faq__question');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        items.forEach(function (other) {
          other.setAttribute('data-open', 'false');
          var oq = other.querySelector('.faq__question');
          if (oq) oq.setAttribute('aria-expanded', 'false');
        });
        item.setAttribute('data-open', isOpen ? 'false' : 'true');
        q.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
    /* Open the first question by default */
    if (items.length && !list.querySelector('.faq__item[data-open="true"]')) {
      items[0].setAttribute('data-open', 'true');
      var fq = items[0].querySelector('.faq__question');
      if (fq) fq.setAttribute('aria-expanded', 'true');
    }
  });
})();

/* ---------- Axle demo tabs ---------- */
(function () {
  var groups = document.querySelectorAll('[data-axle-tabs]');
  groups.forEach(function (tabs) {
    var section = tabs.closest('.axle-showcase') || document;
    var scenes = section.querySelectorAll('.axle-scene');
    tabs.querySelectorAll('.axle-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var scenario = tab.getAttribute('data-scenario');
        tabs.querySelectorAll('.axle-tab').forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        scenes.forEach(function (scene) {
          scene.setAttribute('data-active', scene.getAttribute('data-scenario') === scenario ? 'true' : 'false');
        });
      });
    });
  });
})();

/* ---------- Cart count ---------- */
function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var bubble = document.getElementById('cart-count-bubble');
      if (!bubble) return;
      bubble.textContent = cart.item_count > 0 ? cart.item_count : '';
    })
    .catch(function () {});
}

/* ---------- Product form: add to cart + optional direct checkout ---------- */
(function () {
  updateCartCount();
  document.addEventListener('cart:updated', updateCartCount);

  var form = document.getElementById('product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var addBtn = this.querySelector('[name="add"]');
      if (!addBtn || addBtn.disabled) return;
      var direct = addBtn.dataset.directCheckout === 'true';
      if (!direct) return;

      e.preventDefault();
      var original = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Processing…';

      var variantId = (document.getElementById('product-variant-id') || {}).value;
      var qtyInput = this.querySelector('[name="quantity"]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (!variantId) { addBtn.disabled = false; addBtn.textContent = original; return; }

      var params = new URLSearchParams();
      params.append('id', variantId);
      params.append('quantity', qty.toString());

      fetch('/cart/add.js', {
        method: 'POST',
        body: params.toString(),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        credentials: 'same-origin'
      })
        .then(function (r) { if (!r.ok) { return r.json().then(function (er) { throw new Error(er.description || 'Add failed'); }); } return r.json(); })
        .then(function () { updateCartCount(); window.location.replace('/checkout'); })
        .catch(function () {
          addBtn.disabled = false; addBtn.textContent = original;
          addBtn.removeAttribute('data-direct-checkout');
          form.submit();
        });
    });
  }
})();

/* ---------- Product variant selection ---------- */
(function () {
  var json = document.getElementById('product-variants-json');
  var hidden = document.getElementById('product-variant-id');
  if (!json || !hidden) return;
  var variants;
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;

  var selects = document.querySelectorAll('.product-section__variant-select');
  if (!selects.length) return;

  var priceEl = document.querySelector('.product-section__price--current');
  var compareEl = document.querySelector('.product-section__price--compare');
  var btn = document.getElementById('AddToCart');
  var currency = (function () {
    /* Derive currency formatting from the server-rendered price */
    if (priceEl) {
      var txt = priceEl.textContent.trim();
      var num = txt.replace(/[0-9.,\s]/g, '');
      if (num) return num;
    }
    return '$';
  })();

  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return currency + amount;
  }

  function currentVariant() {
    var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var all = true;
      for (var j = 0; j < opts.length; j++) {
        if (v.options[j] !== opts[j]) { all = false; break; }
      }
      if (all) return v;
    }
    return null;
  }

  function update() {
    var match = currentVariant();
    if (!match) {
      if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
      return;
    }
    hidden.value = match.id;
    if (priceEl) priceEl.textContent = money(match.price);
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.style.display = '';
        compareEl.textContent = money(match.compare_at_price);
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (btn) {
      btn.disabled = !match.available;
      btn.textContent = match.available ? 'Buy Now' : 'Sold out';
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
  update();
})();

/* ---------- Product image thumbnails ---------- */
(function () {
  var thumbs = document.querySelectorAll('.product-section__thumbnail');
  var main = document.getElementById('ProductImage');
  if (!thumbs.length || !main) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      var img = this.querySelector('img');
      if (img) { main.src = img.src.replace('width=150', 'width=800'); main.alt = img.alt; }
    });
  });
})();

/* ---------- Cart page quantity ---------- */
(function () {
  var inputs = document.querySelectorAll('.cart-items-section__quantity-input');
  var buttons = document.querySelectorAll('.cart-items-section__quantity-btn');
  inputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var f = document.getElementById('cart');
      if (f && this.value > 0) f.submit();
    });
  });
  buttons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var action = this.dataset.action;
      var key = this.dataset.key;
      var input = document.getElementById('updates_' + key);
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (action === 'increase') input.value = val + 1;
      else if (action === 'decrease' && val > 1) input.value = val - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
